module.exports = __webpack_public_path__ + "img/20.c455688e.png";